import { select, takeEvery, takeLeading } from "starfx";

import { identityACtx, isOk, safeLast } from "../helpers";
import { schema } from "../schema";
import { xApi, xThunk } from "../xapis";

const db = schema;

import type { TUIInvoiceOverall } from "../schema/uiInvoiceMain.def";
import type { Result } from "starfx";
// Simplified fixNull function
const fixNull = (x: any) =>
  x === undefined || x === null || x.trim?.() === "" || x.trim?.() === "null"
    ? null
    : x;

export const sfxPreserveTrackState = xThunk.create<Partial<TUIInvoiceOverall>>(
  "xThunk/insider/preserveTrackState",
  { supervisor: takeEvery },
  function* (ctx, next) {
    const crtstate = yield* select(db.uiInvoiceOverall.select);
    const newState = { ...crtstate, ...ctx.payload };
    yield* schema.update(db.uiInvoiceOverall.set(newState));
    yield* next();
  }
);

export const restoreTrackState = xThunk.create(
  "xThunk/insider/restoreTrackState",
  { supervisor: takeLeading },
  function* (ctx, next) {
    yield* next();
  }
);

// export const _deprecate_sfxPreserveTrackStateApi = xApi.post<
//   Partial<TUIInvoiceOverall>
// >(
//   "xApi/insider/trackTreeState",
//   { supervisor: takeLeading },
//   function* (ctx, next) {
//     // const crtstate = yield* select(db.uiInvoiceOverall.select);
//     // const newState = { ...crtstate, ...ctx.payload };
//     // yield* schema.update(db.uiInvoiceOverall.set(newState));

//     // yield* sleep(100);
//     const newState = ctx.payload;
//     if (!fixNull(newState.selectedCIF) || !fixNull(newState.currentCurrency)) {
//       return;
//     }
//     ctx.request = ctx.req({
//       url: "/assets/trackState",
//       method: "POST",
//       body: JSON.stringify({ data: newState }),
//     });
//     yield* next();
//   }
// );

export const _deprecate_restoreTrackStateApi = xApi.get(
  "inapi/insider/trackTreeState",
  { supervisor: takeLeading },
  function* (ctx, next) {
    ctx.request = ctx.req({
      method: "GET",
      url: "/assets/trackState",
    });
    yield* next();
    const data = yield* safeLast(identityACtx(ctx));
    const _data = data as Result<TUIInvoiceOverall>;
    if (isOk(_data)) {
      const existing = yield* select(schema.uiInvoiceOverall.select);
      yield* schema.update(
        schema.uiInvoiceOverall.set({ ...existing, ...(_data.value || {}) })
      );
      return;
    }
  }
);
